"use client"
import React, { useEffect } from 'react';
import './NotFound.css';
import { motion } from 'framer-motion';
import { Sparkels } from '../../Components';
import { Link } from 'react-router-dom';

export default function NotFound() {

  useEffect(() => {
    document.body.classList.add('darkMode');
    document.body.classList.add('dark');
  }, []);

  return (
    <div className='notfound_container'>
      <motion.div
        initial={{ opacity: 0.0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.1,
          duration: 0.8,
          ease: "easeInOut",
        }}
        className="notfound_header"
      >
        <h1 className='notfound_title'>
          404
        </h1>
        <Sparkels />
        <h3 className='notfound_subtitle'>
          Page Not Found
        </h3>
        <div className="font-extralight text-base md:text-xl text-neutral-200 py-4 w-[100%] max-w-[800px] text-center">
          The page you're looking for doesn't exist or has been moved
        </div>
      </motion.div>
      
      <div className='notfound_content'>
        <motion.div
          initial={{ opacity: 0.0, y: 70 }}
          whileInView={{ opacity: 1, y: 30 }}
          transition={{
            delay: 0.2,
            duration: 0.6,
            ease: "easeInOut",
          }}
          viewport={{ once: true, amount: 0.3 }}
          className="notfound_section"
        >
          <h4 className="notfound_section_title">🏠 Go Back Home</h4>
          <p className="notfound_text">
            Return to our homepage and explore all the powerful chess analysis tools that ChessCloud has to offer.
          </p>
          <Link to="/" className="notfound_button">
            Back to Home
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0.0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.3,
            duration: 0.6,
            ease: "easeInOut",
          }}
          viewport={{ once: true, amount: 0.3 }}
          className="notfound_section"
        >
          <h4 className="notfound_section_title">🔍 What You Can Do</h4>
          <p className="notfound_text">
            • Check the URL for any typos<br/>
            • Use the navigation menu to find what you're looking for<br/>
            • Visit our About page to learn more about ChessCloud<br/>
            • Contact us if you think this is an error
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0.0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.4,
            duration: 0.6,
            ease: "easeInOut",
          }}
          viewport={{ once: true, amount: 0.3 }}
          className="notfound_section"
        >
          <h4 className="notfound_section_title">⚡ Popular Pages</h4>
          <div className="notfound_links">
            <Link to="/about" className="notfound_link">About ChessCloud</Link>
            <Link to="/pricing" className="notfound_link">Pricing</Link>
            <Link to="/contact" className="notfound_link">Contact Us</Link>
          </div>
        </motion.div>
      </div>
    </div>
  )
}
